const EventTopFilter = (function () {
  const triggerElement = $(".js-event-button");
  const $topbar = $(".js-topbar");

  function init() {
    if ($(triggerElement).length === 0 || Global.debug.disableTopbar) {
      return;
    }
    ScrollTrigger.create({
      id: "sticky-event-topbar",
      trigger: triggerElement,
      start: () => "bottom top",
      endTrigger: $("body"),
      end: "bottom+=100 bottom",
      onToggle: (self) => {
        if (self.isActive) {
          $topbar.addClass("is-active");
          $("body").addClass("has-sticky-top");
        } else {
          $topbar.removeClass("is-active");
          $("body").removeClass("has-sticky-top");
        }
      },
    });
  }
  // Updating metrics on resize is automatically done by ScrollTrigger.

  return {
    init,
  };
})();
